// extracted by mini-css-extract-plugin
var _1 = "legendLingraph-module_gradient___wAgLE";
var _2 = "legendLingraph-module_icon__DmbxIR";
var _3 = "legendLingraph-module_iconRuble__fx8tZ_";
var _4 = "legendLingraph-module_miniContainer__zMkxOP";
var _5 = "legendLingraph-module_root__PcFHlt";
var _6 = "legendLingraph-module_section_icon__BwWX6p";
var _7 = "legendLingraph-module_space__ddRz9W";
var _8 = "legendLingraph-module_title__cwFriZ";
export { _1 as "gradient", _2 as "icon", _3 as "iconRuble", _4 as "miniContainer", _5 as "root", _6 as "section_icon", _7 as "space", _8 as "title" }
